import React from 'react';
import { Link } from 'react-router-dom';
import routes from '../../resources/routes';
import { Container, Paper } from '@material-ui/core';
import './NotFoundPage.scss';

const NotFoundPage: React.FC = () => {
    return (
        <Container component="main" maxWidth="sm">
            <Paper className="paper">
                Not found. <Link to={routes.HOME}>Back to home</Link>
            </Paper>
        </Container>
    );
};

export default NotFoundPage;
